const NormalHelper = {};

// 获取时间戳
export function getClientToken() {
  return Date.parse(new Date());
}

export default NormalHelper;



// WEBPACK FOOTER //
// ./src/common/NormalHelper.js